import { render } from "./slide28.vue?vue&type=template&id=65d98aca&scoped=true"
import script from "./slide28.vue?vue&type=script&lang=js"
export * from "./slide28.vue?vue&type=script&lang=js"

import "./slide28.vue?vue&type=style&index=0&id=65d98aca&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d98aca"]])

export default __exports__